import { Fragment } from "react";
import { Grid, useMediaQuery } from "@mui/material";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { useFetchQuery } from "@dzambalaorg/react-hooks";
import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { ModuleType, TokenType, type IToken } from "@framework/types";

import { TokenSearchForm, TokenListItem } from "../../../../components";

export interface IErc721TokenListProps {
  embedded?: boolean;
}

export const Erc721TokenList = (props: IErc721TokenListProps) => {
  const { embedded } = props;

  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IToken>
  >("/erc721/tokens", { enableInfiniteScroll: isMd });

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "erc721", "erc721.tokens"]} isHidden={embedded} />

      <PageHeader message="pages.erc721.tokens.title" />

      <TokenSearchForm contractType={[TokenType.ERC721]} contractModule={[ModuleType.HIERARCHY]} />

      <ProgressOverlay isLoading={isLoading}>
        <Grid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(token => (
              <Grid size={{ lg: 4, sm: 6, xs: 12 }} key={token.id}>
                <TokenListItem token={token} path="/erc721/tokens" />
              </Grid>
            ))}
          </StyledEmptyWrapper>
        </Grid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
